import { createSlice } from "@reduxjs/toolkit";
import { getSportTicketList } from "./thunk";

const getSportTicketListSlice = createSlice({
    name: "getSportTicketListSlice",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getSportTicketList.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getSportTicketList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getSportTicketList.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

    }
});

export default getSportTicketListSlice.reducer;